var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('parts',{attrs:{"title":"テキスト開始"},on:{"remove":function($event){return _vm.$emit('remove')}}},[_c('td')])}
var staticRenderFns = []

export { render, staticRenderFns }